import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useLocalStorageStore } from '@/stores/localStorage';

const checkOutboundSubRouter = () => {
  const { t } = useI18n();
  const authStore = useAuthStore();
  const sessionToken = authStore.sessionToken;
  const clientInfo = authStore.clientInfo;
  const routers = [
    {
      path: 'parcel',
      name: t('router.outbound-parcel'),
    },
    {
      path: 'quick',
      name: t('router.outbound-quick'),
    },
    {
      path: 'mass-parcel',
      name: t('router.outbound-mass-parcel'),
    },
  ];
  if (!sessionToken) return routers;

  if (clientInfo.registeredMail && clientInfo.registeredMail.enabled)
    routers.push({
      path: 'registry',
      name: t('router.outbound-registry'),
    });

  if (clientInfo.ems && clientInfo.ems.enabled && clientInfo.dhl && clientInfo.dhl.enabled)
    routers.push({
      path: 'global',
      name: t('router.outbound-global'),
    });

  return routers;
};

const useRenderRouter = () => {
  const { t } = useI18n();
  const router = useRouter();
  const routerList = [
    // 주문접수

    {
      path: '/outbound',
      name: t('router.outbound'),
      children: checkOutboundSubRouter(),
    },

    // 주문조회

    {
      path: '/tracking',
      name: t('router.tracking'),
      children: [
        {
          path: 'outbound',
          name: t('router.tracking-outbound'),
        },
      ],
    },

    // 고객지원

    {
      name: t('router.help'),
      path: '/help',
      children: [
        {
          path: 'notice',
          name: t('router.help-notice'),
        },
        {
          path: 'faq',
          name: t('router.help-faq'),
        },
      ],
    },
    // 서비스 소개

    {
      path: '/service',
      name: '서비스소개',
    },
  ];

  // 마이페이지
  const mypageRouterList = {
    path: '/mypage',
    name: t('router.mypage'),
    children: [
      {
        path: 'profile',
        name: t('router.mypage-profile'),
      },
      {
        path: 'billing',
        name: t('router.mypage-billing'),
      },
      {
        path: 'unit',
        name: t('router.mypage-unit'),
      },
    ],
  };

  const actionSignOut = () => {
    const authStore = useAuthStore();
    authStore.updateSessionToken('');
    authStore.updateClientInfo({
      name: '',
    } as any);
    authStore.updateCenterInfo({
      name: '',
    } as any);
    useLocalStorageStore().saveToLocalStorage();
    router.push('/');
  };
  return {
    router,
    routerList,
    mypageRouterList,
    actionSignOut,
  };
};

export default useRenderRouter;
